export default class Tooltip {
  constructor() {
    this.setup();
  }
  setup() {
    $('[data-toggle="tooltip"]').tooltip();
  }
}
